import { ApiProperty } from "@nestjs/swagger";

export class SoItemRequest{
    @ApiProperty()
    saleOrderItemId: number;
}